// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/notesEditor/trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_main_notes_widget {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.notes_widget_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.notes_widget_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.notes_widget_filter_icon:hover {
    opacity: 1;
}

.notes_widget_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.notes_widget_filter_icon--active:hover {
    opacity: 1;
}

.notes_widget_add_wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.notes_widget_add_wrapper:hover {
    opacity: 1;
}

.notes_widget_add_button {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.notes_widget_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
    white-space: nowrap;
}

.notes_widget_content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-right: 4px;
}

.notes_widget_list {
    display: flex;
    flex-direction: column;
    gap: 0;
    background: #FFFFFF;
    border-radius: 8px;
    overflow-y: auto;
    max-height: 100%;
}

.notes_widget_list > * {
    flex-shrink: 0;
}

.notes_widget_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 0;
}

.notes_widget_empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 20px 0;
}

.notes_widget_empty_text {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
}

.notes_widget_empty_action {
    color: #007AFF;
    font-size: calc(13px * var(--fontScaler));
    text-decoration: none;
    cursor: pointer;
    font-weight: 500;
}

.notes_widget_empty_action:hover {
    color: #0051D5;
    text-decoration: underline;
}

/* Note Item Styles */
.note_widget_item {
    background: #FFFFFF;
    border-bottom: 0.5px solid #E5E5EA;
    overflow: hidden;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.note_widget_item:last-child {
    border-bottom: none;
}

.note_widget_item:hover:not(.note_widget_item--expanded) {
    background: #FAFAFA;
}

.note_widget_item--expanded {
    background: #F9F9FB;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);
    border-bottom: 0.5px solid #E5E5EA;
}

.note_widget_item_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.note_widget_item_left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
}

.note_widget_item_preview {
    padding: 12px 16px;
    border-top: 0.5px solid #F5F5F7;
    max-height: 300px;
    overflow-y: auto;
}

.note_widget_preview_text {
    font-size: calc(13px * var(--fontScaler));
    line-height: 1.5;
    color: #3C3C43;
}

.note_widget_item_actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.note_widget_footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
}

.note_widget_delete_icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.note_widget_delete_icon:hover {
    opacity: 1;
}

.note_widget_item_title {
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 20px;
    color: #1D1D1F;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.note_widget_item_date {
    font-weight: 400;
    font-size: calc(11px * var(--fontScaler));
    line-height: 16px;
    color: #86868B;
    white-space: nowrap;
    flex-shrink: 0;
}

/* Expanded Content */
.note_widget_item_content {
    padding: 0 16px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-top: 0.5px solid #F5F5F7;
    margin-top: 8px;
    padding-top: 12px;
}

.note_widget_edit_section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.note_widget_title_input {
    width: 100%;
    padding: 8px 12px;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
    background: #F9F9FB;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    outline: none;
    transition: all 0.2s ease;
}

.note_widget_title_input:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.note_widget_bound_toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: calc(12px * var(--fontScaler));
    color: #86868B;
    transition: color 0.2s;
    user-select: none;
}

.note_widget_bound_toggle:hover {
    color: #1D1D1F;
}

.note_widget_bound_toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #007AFF;
}

/* Toolbar for rich text editing */
.note_widget_toolbar {
    display: flex;
    gap: 4px;
    padding: 4px;
    background: #FAFAFA;
    border: 0.5px solid #E5E5EA;
    border-radius: 6px;
}

.note_widget_toolbar_btn {
    padding: 5px 10px;
    background: #FFFFFF;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    cursor: pointer;
    font-size: calc(12px * var(--fontScaler));
    transition: all 0.2s ease;
    color: #1D1D1F;
}

.note_widget_toolbar_btn:hover {
    background: #F5F5F7;
    border-color: #007AFF;
}

.note_widget_toolbar_btn:active {
    background: #E5E5EA;
}

/* Rich text editor (contentEditable) */
.note_widget_text_editor {
    width: 100%;
    height: 100px;
    padding: 12px;
    font-size: calc(13px * var(--fontScaler));
    line-height: 1.5;
    color: #1D1D1F;
    background: #F9F9FB;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    outline: none;
    overflow-y: auto;
    font-family: inherit;
    transition: all 0.2s ease;
}

.note_widget_text_editor:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.note_widget_text_editor:empty:before {
    content: attr(placeholder);
    color: #86868B;
}

/* Saving Indicator */
.note_widget_saving_indicator {
    font-size: calc(11px * var(--fontScaler));
    color: #86868B;
    font-style: italic;
    margin-top: 4px;
}

/* Scrollbar Styling - macOS style */
.notes_widget_content::-webkit-scrollbar,
.note_widget_text_editor::-webkit-scrollbar {
    width: 8px;
}

.notes_widget_content::-webkit-scrollbar-track,
.note_widget_text_editor::-webkit-scrollbar-track {
    background: transparent;
}

.notes_widget_content::-webkit-scrollbar-thumb,
.note_widget_text_editor::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    border: 2px solid #FFFFFF;
}

.notes_widget_content::-webkit-scrollbar-thumb:hover,
.note_widget_text_editor::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/notesWidget/NotesWidget.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,yDAAiE;IACjE,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yCAAyC;IACzC,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,yCAAyC;IACzC,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA,oCAAoC;AACpC;;IAEI,UAAU;AACd;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;AAClC","sourcesContent":[".dashboard_main_notes_widget {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.notes_widget_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.notes_widget_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.notes_widget_filter_icon:hover {\n    opacity: 1;\n}\n\n.notes_widget_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.notes_widget_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.notes_widget_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.notes_widget_add_wrapper:hover {\n    opacity: 1;\n}\n\n.notes_widget_add_button {\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.notes_widget_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n    white-space: nowrap;\n}\n\n.notes_widget_content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n    padding-right: 4px;\n}\n\n.notes_widget_list {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    background: #FFFFFF;\n    border-radius: 8px;\n    overflow-y: auto;\n    max-height: 100%;\n}\n\n.notes_widget_list > * {\n    flex-shrink: 0;\n}\n\n.notes_widget_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 0;\n}\n\n.notes_widget_empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 0;\n}\n\n.notes_widget_empty_text {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n}\n\n.notes_widget_empty_action {\n    color: #007AFF;\n    font-size: calc(13px * var(--fontScaler));\n    text-decoration: none;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.notes_widget_empty_action:hover {\n    color: #0051D5;\n    text-decoration: underline;\n}\n\n/* Note Item Styles */\n.note_widget_item {\n    background: #FFFFFF;\n    border-bottom: 0.5px solid #E5E5EA;\n    overflow: hidden;\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.note_widget_item:last-child {\n    border-bottom: none;\n}\n\n.note_widget_item:hover:not(.note_widget_item--expanded) {\n    background: #FAFAFA;\n}\n\n.note_widget_item--expanded {\n    background: #F9F9FB;\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);\n    border-bottom: 0.5px solid #E5E5EA;\n}\n\n.note_widget_item_head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.note_widget_item_left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n}\n\n.note_widget_item_preview {\n    padding: 12px 16px;\n    border-top: 0.5px solid #F5F5F7;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.note_widget_preview_text {\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 1.5;\n    color: #3C3C43;\n}\n\n.note_widget_item_actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.note_widget_footer {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 8px;\n}\n\n.note_widget_delete_icon {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n    cursor: pointer;\n    background-image: url('../../../../assets/notesEditor/trash.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.note_widget_delete_icon:hover {\n    opacity: 1;\n}\n\n.note_widget_item_title {\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 20px;\n    color: #1D1D1F;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    min-width: 0;\n}\n\n.note_widget_item_date {\n    font-weight: 400;\n    font-size: calc(11px * var(--fontScaler));\n    line-height: 16px;\n    color: #86868B;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n/* Expanded Content */\n.note_widget_item_content {\n    padding: 0 16px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    border-top: 0.5px solid #F5F5F7;\n    margin-top: 8px;\n    padding-top: 12px;\n}\n\n.note_widget_edit_section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.note_widget_title_input {\n    width: 100%;\n    padding: 8px 12px;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n    background: #F9F9FB;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.note_widget_title_input:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.note_widget_bound_toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: calc(12px * var(--fontScaler));\n    color: #86868B;\n    transition: color 0.2s;\n    user-select: none;\n}\n\n.note_widget_bound_toggle:hover {\n    color: #1D1D1F;\n}\n\n.note_widget_bound_toggle input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: #007AFF;\n}\n\n/* Toolbar for rich text editing */\n.note_widget_toolbar {\n    display: flex;\n    gap: 4px;\n    padding: 4px;\n    background: #FAFAFA;\n    border: 0.5px solid #E5E5EA;\n    border-radius: 6px;\n}\n\n.note_widget_toolbar_btn {\n    padding: 5px 10px;\n    background: #FFFFFF;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: calc(12px * var(--fontScaler));\n    transition: all 0.2s ease;\n    color: #1D1D1F;\n}\n\n.note_widget_toolbar_btn:hover {\n    background: #F5F5F7;\n    border-color: #007AFF;\n}\n\n.note_widget_toolbar_btn:active {\n    background: #E5E5EA;\n}\n\n/* Rich text editor (contentEditable) */\n.note_widget_text_editor {\n    width: 100%;\n    height: 100px;\n    padding: 12px;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 1.5;\n    color: #1D1D1F;\n    background: #F9F9FB;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    outline: none;\n    overflow-y: auto;\n    font-family: inherit;\n    transition: all 0.2s ease;\n}\n\n.note_widget_text_editor:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.note_widget_text_editor:empty:before {\n    content: attr(placeholder);\n    color: #86868B;\n}\n\n/* Saving Indicator */\n.note_widget_saving_indicator {\n    font-size: calc(11px * var(--fontScaler));\n    color: #86868B;\n    font-style: italic;\n    margin-top: 4px;\n}\n\n/* Scrollbar Styling - macOS style */\n.notes_widget_content::-webkit-scrollbar,\n.note_widget_text_editor::-webkit-scrollbar {\n    width: 8px;\n}\n\n.notes_widget_content::-webkit-scrollbar-track,\n.note_widget_text_editor::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.notes_widget_content::-webkit-scrollbar-thumb,\n.note_widget_text_editor::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    border: 2px solid #FFFFFF;\n}\n\n.notes_widget_content::-webkit-scrollbar-thumb:hover,\n.note_widget_text_editor::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
